const isProduction = () => {
    const hostname = window.location?.hostname;

    return `${hostname}`.indexOf('eduki.com') >= 0;
};

export default isProduction;
